module.exports = __webpack_public_path__ + "img/icon-team-1.848a75eb.svg";